import React from 'react';
import { T } from '../../constants';

const CONFIG = {
  TRADE:   { bg: T.bullBg,   border: T.bullBorder,   color: T.bull },
  OBSERVE: { bg: T.purpleBg, border: T.purpleBorder,  color: T.purple },
  EXIT:    { bg: 'rgba(255,165,0,0.12)', border: 'rgba(255,165,0,0.35)', color: '#ffa500' },
  'STOP LOSS': { bg: 'rgba(239,68,68,0.14)', border: 'rgba(239,68,68,0.45)', color: '#ef4444' },
  BLOCK:   { bg: 'rgba(79,89,102,0.12)', border: 'rgba(79,89,102,0.3)', color: T.textDim },
};

export default function ActionBadge({ action }) {
  const cfg = CONFIG[action] || CONFIG.BLOCK;
  return (
    <span className="badge" style={{
      background: cfg.bg,
      border:     `1px solid ${cfg.border}`,
      color:      cfg.color,
      letterSpacing: '0.07em',
    }}>
      {action}
    </span>
  );
}
